(() => {
  "use strict";

  const SILHOUETTE_DESKTOP = window.matchMedia("(min-width: 1024px)");
  let silhouetteDesktopBound = false;

  function isSilhouetteDesktop() {
    return SILHOUETTE_DESKTOP.matches;
  }

  function getSilhouettePanel(shop, blockId) {
    return (
      shop.querySelector(`.silhouette-panels-col .silhouette-item__panel[data-block-id="${CSS.escape(blockId)}"]`) ||
      shop.querySelector(`.silhouette-layout__mobile .silhouette-item[data-block-id="${CSS.escape(blockId)}"] .silhouette-item__panel`)
    );
  }

  function panelProductCount(panel) {
    if (!panel) return 0;
    return panel.querySelectorAll(".vs-product-card").length;
  }

function syncSilhouetteRails(panel) {
    if (!panel) return;
    const rail = panel.querySelector(".js-vs-silhouette-rail");
    const wrap = panel.querySelector(".silhouette-rail-wrap");
    if (!rail || !wrap) return;

    const prev = wrap.querySelector(".js-vs-silhouette-rail-prev");
    const next = wrap.querySelector(".js-vs-silhouette-rail-next");
    if (!prev || !next) return;

    const updateButtons = () => {
      const maxScroll = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = maxScroll <= 1 || rail.scrollLeft >= maxScroll - 1;
    };

    if (wrap.dataset.vsSilhouetteRailInit !== "true") {
      wrap.dataset.vsSilhouetteRailInit = "true";

      const scrollByCard = (direction) => {
        const card = rail.querySelector(".silhouette-rail__item");
        const gap = Number.parseFloat(getComputedStyle(rail).gap) || 16;
        const amount = card ? card.offsetWidth + gap : rail.clientWidth * 0.88;
        rail.scrollBy({ left: direction * amount, behavior: "smooth" });
      };

      prev.addEventListener("click", () => scrollByCard(-1));
      next.addEventListener("click", () => scrollByCard(1));
      rail.addEventListener("scroll", updateButtons, { passive: true });
    }

    rail.scrollLeft = 0;
    updateButtons();
  }

  function firstBlockWithProducts(shop) {
    const panels = [...shop.querySelectorAll(".silhouette-panels-col .silhouette-item__panel, .silhouette-layout__mobile .silhouette-item__panel")];
    const match = panels.find((panel) => panelProductCount(panel) > 0);
    return match ? match.getAttribute("data-block-id") : panels[0]?.getAttribute("data-block-id");
  }

  function setSilhouetteDesktop(shop, blockId) {
    shop.querySelectorAll(".silhouette-tabs-col .silhouette-tab").forEach((btn) => {
      const active = btn.getAttribute("data-block-id") === blockId;
      btn.setAttribute("aria-pressed", active ? "true" : "false");
      btn.setAttribute("aria-expanded", "false");
    });

    let activePanel = null;
    shop.querySelectorAll(".silhouette-panels-col .silhouette-item__panel").forEach((panel) => {
      const active = panel.getAttribute("data-block-id") === blockId;
      panel.hidden = !active;
      if (active) activePanel = panel;
    });

    if (activePanel) syncSilhouetteRails(activePanel);
  }

  function toggleSilhouetteMobile(shop, blockId) {
    const item = shop.querySelector(`.silhouette-layout__mobile .silhouette-item[data-block-id="${CSS.escape(blockId)}"]`);
    if (!item) return;

    const willExpand = !item.classList.contains("is-expanded");

    shop.querySelectorAll(".silhouette-layout__mobile .silhouette-item").forEach((entry) => {
      const expanded = entry === item && willExpand;
      entry.classList.toggle("is-expanded", expanded);
      const btn = entry.querySelector(".silhouette-tab");
      const panel = entry.querySelector(".silhouette-item__panel");
      if (panel) panel.hidden = !expanded;
      if (btn) {
        btn.setAttribute("aria-pressed", expanded ? "true" : "false");
        btn.setAttribute("aria-expanded", expanded ? "true" : "false");
      }
      if (expanded && panel) syncSilhouetteRails(panel);
    });
  }

  function applySilhouetteLayout(shop) {
    if (isSilhouetteDesktop()) {
      const activeBlockId =
        shop.querySelector(".silhouette-tabs-col .silhouette-tab[aria-pressed='true']")?.getAttribute("data-block-id") ||
        firstBlockWithProducts(shop);

      if (activeBlockId) setSilhouetteDesktop(shop, activeBlockId);

      shop.querySelectorAll(".silhouette-layout__mobile .silhouette-item").forEach((item) => {
        item.classList.remove("is-expanded");
        const panel = item.querySelector(".silhouette-item__panel");
        const btn = item.querySelector(".silhouette-tab");
        if (panel) panel.hidden = true;
        if (btn) {
          btn.setAttribute("aria-pressed", "false");
          btn.setAttribute("aria-expanded", "false");
        }
      });
      return;
    }

    shop.querySelectorAll(".silhouette-tabs-col .silhouette-tab").forEach((btn) => {
      btn.setAttribute("aria-pressed", "false");
      btn.setAttribute("aria-expanded", "false");
    });
    shop.querySelectorAll(".silhouette-panels-col .silhouette-item__panel").forEach((panel) => {
      panel.hidden = true;
    });

    const mobileItems = [...shop.querySelectorAll(".silhouette-layout__mobile .silhouette-item")];
    const hasExpanded = mobileItems.some((item) => item.classList.contains("is-expanded"));

    // On tablet/mobile accordion, open the first tab with products by default.
    if (!hasExpanded) {
      const defaultBlockId = firstBlockWithProducts(shop);
      if (defaultBlockId) {
        const defaultItem = mobileItems.find((item) => item.getAttribute("data-block-id") === defaultBlockId);
        if (defaultItem) defaultItem.classList.add("is-expanded");
      } else if (mobileItems[0]) {
        mobileItems[0].classList.add("is-expanded");
      }
    }

    mobileItems.forEach((item) => {
      const expanded = item.classList.contains("is-expanded");
      const btn = item.querySelector(".silhouette-tab");
      const panel = item.querySelector(".silhouette-item__panel");
      if (panel) panel.hidden = !expanded;
      if (btn) {
        btn.setAttribute("aria-pressed", expanded ? "true" : "false");
        btn.setAttribute("aria-expanded", expanded ? "true" : "false");
      }
      if (expanded && panel) syncSilhouetteRails(panel);
    });
  }

  function initSilhouettes(root = document) {
    const shop = root.querySelector("#silhouette-shop") || root;
    if (!shop || shop.dataset.vsSilhouetteInit === "true") return;
    shop.dataset.vsSilhouetteInit = "true";

    applySilhouetteLayout(shop);

    shop.addEventListener("click", (e) => {
      const btn = e.target.closest(".silhouette-tab[data-block-id]");
      if (!btn || !shop.contains(btn)) return;

      const blockId = btn.getAttribute("data-block-id");
      if (isSilhouetteDesktop()) {
        setSilhouetteDesktop(shop, blockId);
      } else {
        toggleSilhouetteMobile(shop, blockId);
      }
    });

    if (!silhouetteDesktopBound) {
      silhouetteDesktopBound = true;
      SILHOUETTE_DESKTOP.addEventListener("change", () => {
        document.querySelectorAll("#silhouette-shop").forEach((sectionShop) => {
          applySilhouetteLayout(sectionShop);
        });
      });
    }
  }

  function initProductRails() {
    document.querySelectorAll(".js-vs-product-rail:not([data-rail-init])").forEach((rail) => {
      rail.dataset.railInit = "true";
      const wrap = rail.closest(".product-rail-wrap");
      if (!wrap) return;

      const prev = wrap.querySelector(".js-vs-rail-prev");
      const next = wrap.querySelector(".js-vs-rail-next");
      if (!prev || !next) return;

      const updateButtons = () => {
        const maxScroll = rail.scrollWidth - rail.clientWidth;
        prev.disabled = rail.scrollLeft <= 1;
        next.disabled = maxScroll <= 1 || rail.scrollLeft >= maxScroll - 1;
      };

      const scrollByCard = (direction) => {
        const item = rail.querySelector(".product-rail__item");
        const gap = Number.parseFloat(getComputedStyle(rail).gap) || 16;
        const amount = item ? item.offsetWidth + gap : rail.clientWidth * 0.8;
        rail.scrollBy({ left: direction * amount, behavior: "smooth" });
      };

      prev.addEventListener("click", () => scrollByCard(-1));
      next.addEventListener("click", () => scrollByCard(1));
      rail.addEventListener("scroll", updateButtons, { passive: true });
      window.addEventListener("resize", updateButtons);
      updateButtons();
    });
  }

  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach((a) => {
      a.addEventListener("click", (e) => {
        const id = a.getAttribute("href");
        if (!id || id === "#") return;
        const el = document.querySelector(id);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function initClubForm() {
    const section = document.getElementById("club");
    if (!section) return;

    const success = section.querySelector("[data-club-success]");
    if (success) {
      section.scrollIntoView({ behavior: "smooth", block: "center" });
      success.focus({ preventScroll: true });
    }

    const copyBtn = section.querySelector("[data-club-copy]");
    const codeEl = section.querySelector("[data-club-code]");
    if (!copyBtn || !codeEl) return;

    copyBtn.addEventListener("click", async () => {
      const code = codeEl.textContent?.trim();
      if (!code) return;

      try {
        await navigator.clipboard.writeText(code);
        copyBtn.textContent = "Copied!";
      } catch {
        copyBtn.textContent = code;
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initSilhouettes();
    initProductRails();
    initSmoothAnchors();
    initClubForm();
  });

  document.addEventListener("shopify:section:load", (event) => {
    initSilhouettes(event.target);
    initProductRails();
    if (event.target.querySelector?.("#club") || event.target.id === "club") {
      initClubForm();
    }
  });

  document.addEventListener("vs:init-rails", initProductRails);
})();
